/**
 * SİTE FAVICON'U — domainin kendi /favicon.ico dosyası. Yüklenemezse Globe ikonuna
 * düşer. Üçüncü parti favicon servisi kullanılmaz (istek doğrudan siteye gider).
 */
import { useState } from "react";
import { Globe } from "lucide-react";

export function SiteFavicon({ url, size = 20, className = "" }: { url: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  let origin = "";
  try { origin = new URL(url).origin; } catch { /* geçersiz url */ }
  if (!origin || failed) return <Globe className={`text-brand-500 ${className}`} style={{ width: size, height: size }} />;
  return (
    <img
      src={`${origin}/favicon.ico`}
      alt=""
      width={size}
      height={size}
      onError={() => setFailed(true)}
      className={`rounded-sm ${className}`}
      style={{ width: size, height: size, objectFit: "contain" }}
    />
  );
}
